const doc = [({"en":({"adminConstantInventoryUnit":({"guest":"Guest increase/decrease", "room":"Room increase/decrease"})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;